export const configSSO = {
  issuer: 'https://sts.inforius.be',
  postLogoutRedirectUri: 'https://autocam.myinforius.be/callback',
  redirectUri: 'https://autocam.myinforius.be/callback',
  clientId: 'ivalidation',
  oidc: true,
  userinfoEndpoint: 'https://sts.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope: 'openid profile email ivalidation.api',
  showDebugInformation: false,
  silentRefreshRedirectUri: 'https://autocam.myinforius.be/silent-renew.html',
  responseType: 'code',
  enableLogConsole: false
};